module.exports = __webpack_public_path__ + "static/media/36x36-15.79d84169.png";